<mat-spinner *ngIf="!isLoaded"></mat-spinner>

<div class="progamme-container">
<!--{{programme | json}}-->

    <div *ngIf="programme && programme.length >0" >

        <!--AJOITUSSUUNNITELMASIVU-->
        <div >

            <h1 *ngIf="programme">{{globals.getLocalizedValueForTitle(programme[0]?.name)}}<span *ngFor="let tag of programme[0]?.tags">, {{tag?.code}}</span></h1>
            
            <mat-tab-group dynamicHeight mat-stretch-tabs mat-align-tabs="center" >
            <!--dynamicHeight mat-stretch-tabs mat-align-tabs="center" [backgroundColor]="'accent'">-->
                <mat-tab label={{globals.getLocalizedValue(showAccomplishmentPlan)}} >  
                    <div>
                        
                        <!-- Taulun otsakerivit omassa taulussaan-->
                        
                        <button mat-flat-button [matMenuTriggerFor]="viewSelection">{{globals.getLocalizedValue(getSelection(selection))}}</button>
                        
                        <mat-menu #viewSelection="matMenu">
                        <button mat-menu-item (click)="setSelection('schoolyear')" *ngIf="showSchoolYearPlan" [ngClass]="{'selected': selection === 1}">{{globals.getLocalizedValue(showSchoolYearPlan)}}</button>
                        <button mat-menu-item (click)="setSelection('semester')" *ngIf="showSemesterPlan" [ngClass]="{'selected': selection === 2}">{{globals.getLocalizedValue(showSemesterPlan)}}</button>
                        <button mat-menu-item [matMenuTriggerFor]="periodView" *ngIf="!profileName.startsWith('vaasa') && showPeriodPlan" [ngClass]="{'selected': selection === 3}">{{globals.getLocalizedValue(showPeriodPlan)}}</button>
                        <!--<button mat-menu-item [matMenuTriggerFor]="plans">Opintopolut</button>-->
                        </mat-menu>
                    
                        <mat-menu #periodView="matMenu">
                            <div *ngFor="let year of programme[0]?.accomplishmentPlanYearList; index as i">
                                <button mat-menu-item (click)="setAccomplishmentPlanYear(i+1); setSelection('period')"  [ngClass]="{'selected': selectedSchoolYear === i+1}" >
                                    <span>{{globals.getLocalizedValue(getSelectedAcademicYear(i+1))}}</span>
                                </button>
                            </div>
                        </mat-menu>

                        <button mat-flat-button [matMenuTriggerFor]="plans" *ngIf="selectedPlan && accomplishmentPlans.length > 1" disabled={{!isAccomplishmentPlanLoaded}} class="acc-plan-btn">{{globals.getLocalizedValueIfAny(selectedPlan.name)}}</button>
                        <mat-menu #plans="matMenu">
                            <div *ngFor="let plan of accomplishmentPlans; index as i">
                                <button mat-menu-item  (click)="selectAccomplishmentPlan(plan, i)" (click)="selectAccomplishmentPlan2($event, plan, i)" [ngClass]="{'selected': plan === selectedPlan}" >
                                    <span > <!--<span [ngClass]="{'selected': plan === selectedPlan}" tabindex="0">-->
                                        {{globals.getLocalizedValueIfAny(plan.name)}}
                                    </span>
                                </button>
                            </div>
                        </mat-menu>
                        
                        <mat-spinner *ngIf="!isAccomplishmentPlanLoaded" class="acc-plan-spinner"></mat-spinner>
                        
                        <div class="hide-on-med-and-down">   
                        <div *ngIf="programme && isAccomplishmentPlanLoaded" class="hide-on-med-and-down">                           
                            <div class="timing-table">
                                <div class="programme-item">
                                    <div class="programme-item-elem header"></div>
                                    <div *ngIf="creditPoints" class="programme-item-elem centered">{{globals.getLocalizedValue(creditPoints)}}</div>
                                    <!--lukuvuosinäkymän header-->
                                    <div *ngIf="this.selection === 1 && programme[0].accomplishmentPlanYearList != undefined" class="hide-on-small-only">
                                        <div *ngFor="let plan of filterAccomplishmentPlanList(programme[0].accomplishmentPlanYearList); let i = index" class="programme-item-elem centered">
                                            <div>{{i+1}}.{{globals.getAcademicYear()}}</div>
                                        </div>
                                    </div>
                                    <!--lukukausinäkymän header-->
                                    <div *ngIf="this.selection === 2 && programme[0].accomplishmentPlanSemesterList != undefined">
                                        <!--<div class="programme-item-elem centered" *ngFor="let plan of filterAccomplishmentPlanList(programme[0].accomplishmentPlanSemesterList); let i = index">
                                            <div>{{roundUp(((i+1)/2), 1) }}.{{(i+1)%2 > 0 ? globals.getAutumn() : globals.getSpring()}}</div>
                                        </div>-->
                                        <div class="programme-item-elem centered" *ngFor="let plan of filterAccomplishmentPlanList(programme[0].accomplishmentPlanSemesterList); let i = index">
                                            <div>{{ roundUp(((i + 1) / 2), 1) }}.{{ (i + programme[0].startSemester) % 2 === 0 ? globals.getAutumn() : globals.getSpring() }}</div>
                                        </div>
                                    </div>
                                    <!--periodinäkymän header  programme[0].startSemester-->
                                        <!--<div *ngIf="this.selection === 3 && programme[0].accomplishmentPlanPeriodList != undefined"><div class="programme-item-elem centered" *ngFor="let plan of filterAccomplishmentPlanPeriodList(programme[0].accomplishmentPlanPeriodList); let i = index">      
                                            <div>{{i+1}}.p</div>
                                        </div>-->
                                    <div *ngIf="this.selection === 3 && programme[0].accomplishmentPlanPeriodList != undefined">
                                        <!--<div class="programme-item-elem centered" *ngFor="let plan of filterAccomplishmentPlanPeriodList(programme[0].accomplishmentPlanPeriodList, programme[0].accomplishmentPlanYearList); let i = index">
                                            <div>{{i+1}}.p</div>
                                        </div>          -->
                                        <div class="programme-item-elem centered" 
                                            *ngFor="let plan of filterAccomplishmentPlanPeriodList(programme[0].accomplishmentPlanPeriodList, programme[0].accomplishmentPlanYearList); let i = index">
                                            <div>{{ getPeriodNumber(i) }}.p</div>
                                        </div>
                              
                                    </div>
                                </div>
                            </div>

                            <!--taulun rivisisältö generoidaan tähän-->
                            <div class="timing-table">

                                <programme-unit [unit]="programme[0]?.children" [selection]="this.selection" [year]="this.selectedSchoolYear" [learning-path]="selectedPlan?.specialisationOptionId" [period]="this.period" [period-count]="this.periodCount" [start-semester]="programme[0]?.startSemester" [duration]="programme[0]?.duration"></programme-unit>
                            </div>
                        </div>
                        </div>
                        <div *ngIf="programme && isAccomplishmentPlanLoaded" class="hide-on-large-only">
                            <div class="timing-table">
                                <programme-unit-mobile [unit]="programme[0]?.children" [selection]="this.selection" [creditPoints]="this.creditPoints" [year]="this.selectedSchoolYear"  [learning-path]="selectedPath" [period]="this.period" [period-count]="this.periodCount" [start-semester]="programme[0]?.startSemester" [duration]="programme[0]?.duration"></programme-unit-mobile>
                            </div>
                        </div>
                    
                    </div>
                    
                </mat-tab>
                <mat-tab *ngIf="programmeDescription && showDegreeDescription" label={{globals.getLocalizedValue(showDegreeDescription)}}> 
            
                <!-- Kuvaustiedot -->
                    <div >
                        <div *ngFor="let desc of programmeDescription">
                            <div *ngIf="globals.getLocalizedValue(desc?.content)">
                                <h2>{{globals.getLocalizedValue(desc?.title)}}</h2>
                                <app-markdown [body]="globals.getLocalizedValue(desc?.content)"></app-markdown>
                            </div>
                        </div>
                    </div>
                </mat-tab>
            </mat-tab-group>
        </div>

    </div>
</div>

<!--Ajoitussuunnitelma julkaisematta
<div *ngIf="accomplishmentPlanNotFound && !programme[0] && isLoaded">
    <h5 *ngIf="accomplishmentPlanNotFound">{{globals.getLocalizedValue(accomplishmentPlanNotFound)}}</h5>
</div>-->

